import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Giulia R.',
  location: 'Milano'
}, {
  name: 'Francesca B.',
  location: 'Roma'
}, {
  name: 'Chiara M.',
  location: 'Torino'
}, {
  name: 'Valentina S.',
  location: 'Napoli'
}, {
  name: 'Sara F.',
  location: 'Bologna'
}, {
  name: 'Martina C.',
  location: 'Firenze'
}, {
  name: 'Alessia T.',
  location: 'Verona'
}, {
  name: 'Federica L.',
  location: 'Palermo'
}, {
  name: 'Elena P.',
  location: 'Genova'
}, {
  name: 'Giorgia D.',
  location: 'Bari'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    const interval = setInterval(showPopup, 18000);
    setTimeout(showPopup, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-177">
          <div className="bg-white border-2 border-brand-gold shadow-[0_0_20px_rgba(143,122,200,0.28)] rounded-lg p-2.5 pr-8 max-w-[280px] w-full relative overflow-hidden pointer-events-auto" data-id="element-178">
            <div className="absolute top-0 left-0 w-full h-1 bg-brand-rose" data-id="element-179"></div>

            <button onClick={() => setVisible(false)} className="absolute top-1.5 right-1.5 text-brand-taupe/50 hover:text-brand-taupe transition-colors" data-id="element-180">
              <XIcon className="w-4 h-4" data-id="element-181" />
            </button>

            <div className="flex items-center gap-3" data-id="element-182">
              <div className="w-10 h-10 rounded-full bg-brand-rose/10 flex items-center justify-center shrink-0 border border-brand-rose/30" data-id="element-183">
                <ShoppingBag className="w-5 h-5 text-brand-rose" data-id="element-184" />
              </div>
              <div className="leading-tight" data-id="element-185">
                <p className="font-bold text-brand-taupe text-sm" data-id="element-186">
                  {currentPurchase.name}
                </p>
                <p className="text-[11px] text-brand-taupe/70 font-semibold" data-id="element-187">
                  da {currentPurchase.location}, Italia
                </p>
                <p className="text-xs text-brand-rose font-bold mt-0.5" data-id="element-188">
                  ha appena acquistato DANZA READY™
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}